<script lang="ts">
  import type { Piece } from "../lib/stores/library.svelte.js";
  import { playlists } from "../lib/stores/playlists.svelte.js";
  import { ui } from "../lib/stores/ui.svelte.js";
  import Cover from "./Cover.svelte";
  import Icon from "./Icon.svelte";

  /** Zeile fürs Handy: Antippen öffnet Aktionen, „+“ legt in die aktuelle Setlist. */
  let { piece, delay = 0 }: { piece: Piece; delay?: number } = $props();
  const inActive = $derived(playlists.active?.items.includes(piece.id) ?? false);

  async function toggle(): Promise<void> {
    const active = playlists.active;
    if (!active) return;
    if (inActive) await playlists.removeItem(active.id, piece.id);
    else await playlists.add(active.id, piece.id);
  }
</script>

<div class="row" style:animation-delay="{delay}ms">
  <button type="button" class="main" onclick={() => (ui.actionsFor = piece.id)}>
    <span class="mini"><Cover src={piece.thumb} ratio="1" radius="7px" /></span>
    <span class="text">
      <span class="title ellipsis">
        {piece.name}
        {#if piece.favorite}<span class="fav"><Icon name="starFill" size={13} /></span>{/if}
      </span>
      <span class="t3 artist ellipsis">{piece.artist || piece.owner.displayName}</span>
    </span>
  </button>
  <button
    type="button"
    class="add"
    class:done={inActive}
    aria-label={inActive
      ? `Aus „${playlists.active?.name}“ entfernen`
      : `Zu „${playlists.active?.name}“ hinzufügen`}
    aria-pressed={inActive}
    onclick={toggle}
  >
    <Icon name={inActive ? "check" : "plus"} size={18} stroke={2.6} />
  </button>
</div>

<style>
  .row {
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 66px;
    animation: rise var(--dur-sheet) var(--ease-out) both;
  }
  .main {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    min-width: 0;
    text-align: left;
    border-radius: 10px;
  }
  .main:active {
    background: rgba(255, 255, 255, 0.05);
  }
  .mini {
    width: 52px;
    flex: 0 0 52px;
  }
  .text {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }
  .title {
    font-weight: 700;
    font-size: 15px;
  }
  .fav {
    color: var(--accent-2);
    display: inline-flex;
    vertical-align: -1px;
  }
  .artist {
    font-size: 12px;
    font-weight: 600;
  }
  .add {
    width: 40px;
    height: 40px;
    flex: 0 0 40px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.22);
    transition:
      background var(--dur-fast),
      box-shadow var(--dur-fast),
      color var(--dur-fast),
      transform var(--dur-base) var(--ease-pop);
  }
  .add:active {
    transform: scale(0.85);
  }
  .add.done {
    background: var(--accent-3);
    box-shadow: none;
    color: var(--on-accent-3);
    transform: rotate(360deg);
  }
</style>
